/**
 * Styled table primitives.
 *
 *   <Table>
 *     <THead>
 *       <Tr><Th>Col</Th></Tr>
 *     </THead>
 *     <TBody>
 *       <Tr><Td>...</Td></Tr>
 *     </TBody>
 *   </Table>
 */
import { classes } from '@/lib/utils';

export function Table({ children, className, testID }) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-white/8 bg-[#1A1A1A]" data-testid={testID}>
      <table className={classes('w-full text-sm border-collapse', className)}>{children}</table>
    </div>
  );
}

export function THead({ children }) {
  return <thead className="bg-black/30 text-[11px] uppercase tracking-wider text-white/50">{children}</thead>;
}
export function TBody({ children }) {
  return <tbody>{children}</tbody>;
}

export function Tr({ children, onClick, className, testID, ...rest }) {
  return (
    <tr
      onClick={onClick}
      data-testid={testID}
      className={classes(
        'border-b border-white/5 last:border-b-0 transition-colors',
        onClick && 'cursor-pointer hover:bg-white/3',
        className,
      )}
      {...rest}
    >
      {children}
    </tr>
  );
}

export function Th({ children, className, align = 'left' }) {
  return (
    <th
      className={classes(
        'px-4 py-3 font-semibold whitespace-nowrap',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        align === 'left' && 'text-left',
        className,
      )}
    >
      {children}
    </th>
  );
}

export function Td({ children, className, align = 'left' }) {
  return (
    <td
      className={classes(
        'px-4 py-3.5 text-white/85 align-middle',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        align === 'left' && 'text-left',
        className,
      )}
    >
      {children}
    </td>
  );
}
